<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="ruleModal_trriger">        
        <div class="rule-modal u-window">
            <div class="dialog-title t-rule"></div>
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <p v-for="(item,index) in rule_text" :key="index"><em class="tag">{{ index + 1 }}</em>{{ item }}</p>
                </div>
            </div>
            <div class="u-btn ok" @click="closeModal"></div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import GLOBAL from '@/assets/js/global.js';

export default {
    name : 'rule-modal',
    data : function (){
        return {
            ruleModal_trriger : false,
            rule_text : ['活动时间：9月16日~10月15日；',
            '活动时间内，扫描梦三国十二周年庆广告上的二维码可以抽取梦三周年庆卡片。',
            '缺少卡片可以找好友索要，有多余的卡片也可以赠送给好友。',
            '凑齐一套「梦」、「三」、「周」、「年」、「庆」五张卡牌后，可以在页面领取集卡奖励。',
            '同时还有一定概率抽中「纪念熊猫周边」（随机一只）。抽中纪念熊猫的小伙伴可以在页面填写收货地址，梦梦会将周边包邮送到你手中。',
            '“我为亚运赋能 争当火炬手”为杭州2022年亚运会火炬手选拔活动，抽中 「火炬手随机点亮卡」的玩家，可以在“我为亚运赋能 争当火炬手”的活动中，随机点亮一个字，全部点亮有机会成为杭州亚运会火炬手！']
        }
    },
    methods: {
        closeModal(){
            document.body.removeEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.ruleModal_trriger = false;
        }
    },    
}
</script>

<style>
    .t-rule{
        width: 2.12rem;
        height: .55rem;
        margin: 0 auto .2rem;
        background-image: url(~@/assets/images/title-rule.png);
    }

    .rule-modal .dialog-content{
        position: relative;
        width: 7.18rem;
        height: 7.37rem;
        margin: 0 auto .55rem;
        background-image: url(~@/assets/images/bg-rule.png);
    }

    .rule-modal .dialog-wrapper{
        padding: .6rem .6rem 0;
    }

    .rule-modal .u-btn.close{
        position: absolute;
        top: -.6rem;
        right: .8rem;
    }

    .rule-modal p{
        line-height: 0.42rem;
    }

    .rule-modal .tag{
        display: inline-block;
        width: .34rem;
        height: .32rem;
        margin-right: .2rem;
        line-height: .32rem;
        text-align: center;
        color: #4a210b;
        background-image: url(~@/assets/images/label.png);
        vertical-align: middle;
    }    

</style>


// WEBPACK FOOTER //
// src/components/ruleModal.vue